import React, { useState, useEffect } from "react";
import logo from "../res/ajorist-wt.png";
import ManageIssues from "../homePageComp/ManageIssues";

function JournalAdminHome() {
  const [activePage, setActivePage] = useState("Dashboard");

  useEffect(() => {
    document.title = "AJORIST - Admin";
  }, []);

  const NavLink = ({ pageName, children }) => (
    <li>
      <button
        onClick={() => setActivePage(pageName)}
        className={`flex items-center w-full p-2 rounded-lg text-left transition-colors ${
          activePage === pageName
            ? "bg-sky-700 text-white"
            : "text-sky-100 hover:bg-sky-800/60"
        }`}
      >
        {children}
      </button>
    </li>
  );

  const renderContent = () => {
    switch (activePage) {
      case "Dashboard":
        return <div>Welcome to the AJORIST Admin Dashboard!</div>;
      case "Manage Issues":
        return <ManageIssues />;
      case "Submissions":
        return <div>Here you can view and manage submissions.</div>;
      case "Settings":
        return <div>Journal settings will be here.</div>;
      default:
        return <div>Select a page</div>;
    }
  };

  return (
    <div className="flex h-screen bg-slate-100">
      {/* Sidebar */}
      <aside className="w-64 bg-sky-900 text-white flex flex-col">
        <div className="flex items-center justify-center h-20 border-b border-sky-800/50">
          <img src={logo} alt="AJORIST Logo" className="h-12" />
        </div>
        <nav className="flex-1 px-4 py-6">
          <ul className="space-y-2">
            <NavLink pageName="Dashboard">
              <svg
                className="w-6 h-6 mr-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                ></path>
              </svg>
              Dashboard
            </NavLink>
            <NavLink pageName="Manage Issues">
              <svg
                className="w-6 h-6 mr-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 12h6M7 8h6"
                ></path>
              </svg>
              Manage Issues
            </NavLink>
            <NavLink pageName="Submissions">
              <svg
                className="w-6 h-6 mr-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                ></path>
              </svg>
              Submissions
            </NavLink>
          </ul>
        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-10">
        <h1 className="text-3xl font-bold text-slate-800 mb-6">{activePage}</h1>
        <div className="p-6 bg-white rounded-lg shadow">{renderContent()}</div>
      </main>
    </div>
  );
}

export default JournalAdminHome;
